import { render, staticRenderFns } from "./Trunks.vue?vue&type=template&id=2571315f"
import script from "./Trunks.vue?vue&type=script&lang=ts"
export * from "./Trunks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports